import ErrorMessages from './ErrorMessages';

interface SwitchProps {
	checked: boolean;
	disabled?: boolean;
	errorMessages?: string[];
	isValid?: boolean | null;
	label: string;
	name: string;
	onChange: (checked: boolean) => void;
	required?: boolean;
	value: string;
}

export default function Switch({ checked, disabled = false, errorMessages = [], isValid = null, label, name, onChange, required, value }: SwitchProps) {
	const formFieldClasses = ['form-field'];
	if (isValid !== null) {
		formFieldClasses.push(isValid ? 'form-field--valid' : 'form-field--error');
	}

	const inputAttributes = {
		checked,
		disabled,
		id: name,
		name,
		onChange: (event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.checked),
		required,
		role: 'switch',
		type: 'checkbox',
		value,
	};

	return (
		<div className="form-field-wrapper" data-field-name={name}>
			<div className={formFieldClasses.join(' ')} data-field-type="switch" data-field-name={name}>
				<div className="form-binary-input">
					<input {...inputAttributes} />
					<label htmlFor={name} dangerouslySetInnerHTML={{ __html: label }} />
				</div>
			</div>

			<ErrorMessages messages={errorMessages} />
		</div>
	);
}
